import { CSSObject, Theme, forBrands } from '@core-ui/react-stitch';

const sanitizeHexValue = (hex: string) => hex.replace('#', '%23');

export const getSVGFillColor = (theme: Theme,isBRcolor2023FFEnabled:boolean) =>
  forBrands(theme, {
    br: () => sanitizeHexValue(isBRcolor2023FFEnabled?"#000000":theme.color.b2),
    brfs: () => sanitizeHexValue(isBRcolor2023FFEnabled?"#000000":theme.color.b2),
    default: () => sanitizeHexValue(theme.color.gray60),
  });

const getArrowSVG = (theme: Theme,isBRcolor2023FFEnabled:boolean) =>
  `url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='6' viewBox='0 0 9 6'%3E%3Cpath d='M.003 1.533L1.118.529l3.385 3.047L7.89.529l1.114 1.004-4.5 4.05z' style='fill:${getSVGFillColor(
    theme,isBRcolor2023FFEnabled
  )};fill-rule:evenodd' /%3E%3C/svg%3E")`;

export const getControlBeforeStyles = (theme: Theme,isBRcolor2023FFEnabled:boolean): CSSObject => ({
  content: '""',
  background: `${getArrowSVG(theme,isBRcolor2023FFEnabled)} no-repeat`,
  width: '1.5rem',
  height: '2rem',
  display: 'block',
  position: 'absolute',
  right: '1px',
  top: '1px',
  backgroundPositionX: '2px',
  backgroundPositionY: '18px',
});

export default getControlBeforeStyles;
